module.exports = __webpack_public_path__ + "media/images/ready-to-submit-8f28a6c320b1bd8fdf19c8e6aab0ecab.png";